import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';

export class Entitlement extends Model<Schemas['entitlements'], Models> {
    get startsAtDate() {
        return nullableDate(this.startsAt);
    }

    get expiresAtDate() {
        return nullableDate(this.expiresAt);
    }

    get statusLabel() {
        return this.status || 'active';
    }

    get emailDomains() {
        return this.emails.filter((value) => !value.includes('@'));
    }

    get directEmails() {
        return this.emails.filter((value) => value.includes('@'));
    }

    get adminRoute() {
        return {
            name: 'entitlements.edit',
            params: { id: this.id },
        };
    }
}
